export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/por7o-9168f9e02b699e13220f5a30c3555b43.jpg";